import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Discussion, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeDiscussion(request: Boundaries["removeDiscussion"]["request"]): void;
}

function useRemoveDiscussion(discussion: Identifiable<Discussion>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveDiscussionRequestPending(discussion),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveDiscussionRequestSuccess(discussion),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveDiscussionRequestFailure(discussion),
    ),
    removeDiscussion: core.removeDiscussion,
  };
}

export { useRemoveDiscussion };
